import { ExternalLink } from '@ui-components/actions/ExternalLink'
import { FormattedMessage, useIntl } from 'react-intl'

import { AnalyticsService, CommonAnalyticsModalName } from '../../analytics'

export const ConsentPrivacyLink = ({
  analyticsService,
  analyticsCategory,
}: {
  analyticsService: AnalyticsService<string, string, CommonAnalyticsModalName>
  analyticsCategory: string
}) => {
  const intl = useIntl()

  return (
    <div>
      <FormattedMessage
        id="common-consent-privacy-link"
        values={{
          sGroupPrivacyInfoLink: (
            <ExternalLink
              href={intl.formatMessage({ id: 'common-bank-data-processing-link-url' })}
              onClick={() => analyticsService.sendCustomEvent(analyticsCategory, 'PrivacyLink')}
            >
              {intl.formatMessage({ id: 'common-consent-privacy-more-info-link-text' })}
            </ExternalLink>
          ),
        }}
      />
    </div>
  )
}
